import { extendsModule, baseFormItem } from 'src/store/base';
import _ from 'lodash';
import * as types from 'src/store/types';
import tool from 'src/utils/tool';
import apis from 'src/const/apis';
import request from 'src/utils/request';
import { INIT as TITLE_LIST_INIT } from './procedural-creative-title-list';
import { INIT as CTA_LIST_INIT } from './procedural-creative-cta';


const PAGEIDINIT = [];

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-create',
    image_list: [], // image_list即存图片又存视频，差别在于视频元素会多一个video_info属性
    call_to_action_list: _.cloneDeep(CTA_LIST_INIT.call_to_action_list),
    title_list: _.cloneDeep(TITLE_LIST_INIT.title_list),
    page_list: _.cloneDeep(PAGEIDINIT), // leadAds支持程序化创意 这里保存用户选择的线索表单的id
    isSignProtocol: false, // 用户是否勾选了线索表单协议勾选框
    showProtocolTerms: false, // 用户是否签署过leadAds线索表单
  },
  getters: {
    titleList(state) {
      return state.title_list;
    },
    ctaList(state) {
      return state.call_to_action_list;
    },
    formItemData(state) {
      return {
        image_list: state.image_list,
        page_list: state.page_list,
        isSignProtocol: state.isSignProtocol,
        showProtocolTerms: state.showProtocolTerms,
      };
    },
    leadAdsAcoPageList(state) {
      return state.page_list;
    },
  },
  mutations: {
    // 更新用户是否勾选了勾选框
    [types.UPDATE_PCD_LEAD_ADS_ISSIGNPROTOCOL](state, data) {
      state.isSignProtocol = data;
    },
    [types.UPDATE_PCD_LEAD_ADS_SHOW_PRTTOCOLTERMS](state, data) {
      state.showProtocolTerms = data;
    },
    [types.UPDATE_PCD_LEAD_ADS_ACO_PAGE_ID](state, data) {
      state.page_list = data;
    },
    [types.ADD_PCD_ITEM](state, data) {
      state.image_list.push(data);
    },
    [types.ADD_PCD_LIST](state, data = []) {
      state.image_list.push(...data);
    },
    [types.DELETE_PCD_IMAGE](state, index) {
      // image_list是图片与视频混合列表，需要找到第index个image的位置。
      // 有image_info无video_info可以判定是图片
      const targetImageIndex = tool.findNth(state.image_list, index, item => item.image_info && !item.video_info);

      if (targetImageIndex >= 0) {
        state.image_list.splice(targetImageIndex, 1);
      }
    },
    [types.DELETE_PCD_VIDEO](state, index) {
      // image_list是图片与视频混合列表，需要找到第index个video的位置。
      // 有video_info可以判定是视频
      const targetVideoIndex = tool.findNth(state.image_list, index, item => item.video_info);
      if (targetVideoIndex >= 0) {
        state.image_list.splice(targetVideoIndex, 1);
      }
    },
    [types.UPDATE_PCD_VIDEO](state, data) {
      const { value, index } = data;
      // image_list是图片与视频混合列表，需要找到第index个video的位置。
      // 有video_info可以判定是视频
      const targetVideoIndex = tool.findNth(state.image_list, index, item => item.video_info);
      if (targetVideoIndex >= 0) {
        state.image_list.splice(targetVideoIndex, 1, value);
      }
    },
  },
  actions: {
    data2State({ commit }, formData) {
      commit('update', {
        image_list: formData.image_list || [],
        call_to_action_list: formData.call_to_action_list || _.cloneDeep(CTA_LIST_INIT.call_to_action_list),
        title_list: formData.title_list || _.cloneDeep(TITLE_LIST_INIT.title_list),
        page_list: formData.page_list || _.cloneDeep(PAGEIDINIT),
        isSignProtocol: formData.isSignProtocol || false,
        showProtocolTerms: formData.showProtocolTerms || false,
      });
    },
    // 设置视频默认封面，index表示第几个视频
    saveVideoDefaultCover({ commit, state }, { cover, index }) {
      // image_list是图片与视频混合列表，需要找到第index个video在整个image_list的位置
      const targetVideoIndex = tool.findNth(
        state.image_list,
        index,
        item => item.video_info,
      );
      if (targetVideoIndex < 0) {
        return;
      }
      const originVideo = state.image_list[targetVideoIndex];
      const newVideo = {
        ...originVideo,
        image_info: [cover],
      };

      commit(types.UPDATE_PCD_VIDEO, { value: newVideo, index });
    },
    // 设置视频备选封面集，index表示第几个视频
    saveVideoBackupCovers({ commit, state }, { covers, index }) {
      // image_list是图片与视频混合列表，需要找到第index个video在整个image_list的位置
      const targetVideoIndex = tool.findNth(
        state.image_list,
        index,
        item => item.video_info,
      );
      if (targetVideoIndex < 0) {
        return;
      }

      const originVideo = state.image_list[targetVideoIndex];
      const newVideo = {
        ...originVideo,
        video_info: {
          ...originVideo.video_info,
          covers,
        },
      };

      commit(types.UPDATE_PCD_VIDEO, { value: newVideo, index });
    },
    // 获取LeadAds协议签署状态
    getLeadAdsProtocal({ commit }, data) {
      // 处理sonor异味 data命名重复问题
      return request.get(apis.creative.protocalQuery, data).then((res) => {
        const isShow = !res.data.lead_gen_signed;
        commit(types.UPDATE_PCD_LEAD_ADS_SHOW_PRTTOCOLTERMS, isShow);
      }).catch((e) => { });
    },
  },
});
